import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { later } from "@ember/runloop"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import styles from "./date-box.module.css"

@tagName("")
export default class PerspectiveMonthDateBox extends Component {
  readonly styles = styles

  // Args
  dateHash!: Record<string, any>
  visibleCourses!: Array<Course>
  viewedAs!: string
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  currentYearMonth!: string
  classesLinedUp!: boolean
  hasStoppedScrolling!: boolean
  onLessonFocus!: Function
  sidebarIsVisible!: boolean

  // Properties
  canShowContent = true
  canShowDayMenu = false
  typeOfLessonToShow = "titleOnly"
  mouseIsInside = false

  dayMenuConstraints = [{ to: "window", pin: ["left", "right"] }]

  // Services

  // init
  didReceiveAttrs() {
    if (this.hasStoppedScrolling === true) {
      set(this, "canShowContent", true)
    }
  }

  // Cps/getters
  // Actions
  @action
  toggleDayMenu() {
    set(this, "canShowDayMenu", !get(this, "canShowDayMenu"))
    // We want to make sure we don't say we've lost the focus so after the menu apperas, we're lik
    // hey you guys, wstill here
    later(() => {
      if (this.canShowDayMenu === true) this.set("mouseIsInside", true)
    }, 33)
  }

  @action
  onMouseEnter() {
    this.set("mouseIsInside", true)
  }

  @action
  onMouseLeave() {
    this.set("mouseIsInside", false)
  }
}
